import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { TextField } from "./Field";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

const EMPTY = { current: "", next: "", confirm: "" };

export const ProfiloDialog = ({ open, onClose }) => {
  const { user } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const mismatch = f.confirm && f.next !== f.confirm;

  const close = () => { setF(EMPTY); onClose(); };
  const save = async () => {
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password aggiornata"); close();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="profilo-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Il mio profilo</DialogTitle>
          <DialogDescription data-testid="profilo-info">{user?.name} · {user?.email} · {user?.role === "admin" ? "Amministratore" : "Staff"}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <TextField label="Password attuale" type="password" value={f.current} onChange={set("current")} testId="profilo-current-password-input" autoComplete="current-password" />
          <TextField label="Nuova password (min 8 caratteri)" type="password" value={f.next} onChange={set("next")} testId="profilo-new-password-input" autoComplete="new-password" />
          <TextField label="Conferma nuova password" type="password" value={f.confirm} onChange={set("confirm")} testId="profilo-confirm-password-input" autoComplete="new-password" />
          {mismatch && <div className="text-sm text-red-600" data-testid="profilo-mismatch-error">Le password non coincidono</div>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="profilo-cancel-btn">Annulla</Button>
          <Button onClick={save} disabled={loading || !f.current || f.next.length < 8 || f.next !== f.confirm}
            className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="profilo-save-btn">Cambia password</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
